/** @format */

import React from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler,
} from "chart.js";
import { Line } from "react-chartjs-2";
import Card from "./Card";

ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
    Filler
);

const options = {
  responsive: true,
  plugins: {
    legend: {
      display: false,
    },
    title: {
      display: false,
    },
    datalabels: {
      display: false,
    },
    tooltip: {
      backgroundColor: "#1f2937",
      titleColor: "#fff",
      bodyColor: "#d1d5db",
      borderColor: "#4b5563",
      borderWidth: 1,
      callbacks: {
        title: (context) => `Soat: ${context[0].label}:00`, // Tooltip ochilganda soatni chiroyli ko'rsatadi
        label: (context) => `${context.formattedValue} sm`,
      },
    },
  },
  elements: {
    point: {
      radius: 3,
      hoverRadius: 4,
      backgroundColor: "#3B82F6",
      borderWidth: 1,
      borderColor: "#fff",
    },
    line: {
      tension: 0.4,
    },
  },
  scales: {
    y: {
      grid: {
        color: "#E5E7EB",
        borderDash: [4, 4],
      },
      ticks: {
        color: "#6B7280",
      },
      beginAtZero: true,
    },
    x: {
      grid: {
        drawOnChartArea: false,
        color: "#D1D5DB",
      },
      ticks: {
        color: "#6B7280",
        minRotation: 0,
        maxRotation: 0,
        autoSkip: true,
      },
    },
  },
};

const labels = Array(24)
    .fill()
    .map((_, i) => (i + 1).toString());

const Chart7 = ({ data }) => {
  const gradient = (ctx) => {
    const chart = ctx.chart;
    const { ctx: context, chartArea } = chart;
    if (!chartArea) return null;

    const gradient = context.createLinearGradient(
        0,
        chartArea.top,
        0,
        chartArea.bottom
    );
    gradient.addColorStop(0, "rgba(59,130,246,0.3)");
    gradient.addColorStop(1, "rgba(59,130,246,0)");

    return gradient;
  };

  const datas = {
    labels,
    datasets: [
      {
        label: "sm",
        data: data,
        borderColor: "#3B82F6",
        backgroundColor: gradient,
        fill: true,
      },
    ],
  };

  return (
      <Card>
        <div className='chart-box-all'>
          <div>
            {/* TUZATILDI: "soatlik" rejimi xira va kichikroq indeks formatiga o'tkazildi */}
            <h4 className='chart-title'>
              02 Reyka G/P{" "}
              <span className='lower' style={{ opacity: 0.75, marginLeft: '4px' }}>
              soatlik (sm)
            </span>
            </h4>
            <Line options={options} data={datas} height={80} />
          </div>
        </div>
      </Card>
  );
};

export default Chart7;